// พิกัดศูนย์กลางของ 77 จังหวัดในประเทศไทย (latitude, longitude)
const THAILAND_PROVINCE_COORDINATES = [
  // ภาคเหนือ
  { name: 'เชียงราย', lat: 19.9105, lng: 99.8406 },
  { name: 'เชียงใหม่', lat: 18.7883, lng: 98.9853 },
  { name: 'น่าน', lat: 18.7756, lng: 100.7730 },
  { name: 'พะเยา', lat: 19.1664, lng: 99.9019 },
  { name: 'แม่ฮ่องสอน', lat: 19.3020, lng: 97.9654 },
  { name: 'ลำพูน', lat: 18.5744, lng: 99.0087 },
  { name: 'ลำปาง', lat: 18.2888, lng: 99.4907 },
  { name: 'อุตรดิตถ์', lat: 17.6200, lng: 100.0993 },
  { name: 'แพร่', lat: 18.1445, lng: 100.1403 },
  { name: 'ตาก', lat: 16.8840, lng: 99.1259 },
  { name: 'สุโขทัย', lat: 17.0076, lng: 99.8237 },
  { name: 'พิษณุโลก', lat: 16.8211, lng: 100.2659 },
  { name: 'เพชรบูรณ์', lat: 16.4192, lng: 101.1600 },
  { name: 'กำแพงเพชร', lat: 16.4827, lng: 99.5226 },
  { name: 'พิจิตร', lat: 16.4429, lng: 100.3487 },
  { name: 'นครสวรรค์', lat: 15.7030, lng: 100.1371 },
  { name: 'อุทัยธานี', lat: 15.3835, lng: 100.0246 },

  // ภาคตะวันออกเฉียงเหนือ (อีสาน)
  { name: 'หนองคาย', lat: 17.8783, lng: 102.7420 },
  { name: 'บึงกาฬ', lat: 18.3609, lng: 103.6466 },
  { name: 'สกลนคร', lat: 17.1545, lng: 104.1348 },
  { name: 'นครพนม', lat: 17.3920, lng: 104.7695 },
  { name: 'มุกดาหาร', lat: 16.5425, lng: 104.7235 },
  { name: 'อุดรธานี', lat: 17.4156, lng: 102.7872 },
  { name: 'เลย', lat: 17.4860, lng: 101.7223 },
  { name: 'หนองบัวลำภู', lat: 17.2218, lng: 102.4260 },
  { name: 'ขอนแก่น', lat: 16.4322, lng: 102.8236 },
  { name: 'ร้อยเอ็ด', lat: 16.0538, lng: 103.6520 },
  { name: 'มหาสารคาม', lat: 16.1851, lng: 103.3028 },
  { name: 'กาฬสินธุ์', lat: 16.4315, lng: 103.5059 },
  { name: 'ชัยภูมิ', lat: 15.8068, lng: 102.0316 },
  { name: 'นครราชสีมา', lat: 14.9799, lng: 102.0977 },
  { name: 'บุรีรัมย์', lat: 14.9930, lng: 103.1029 },
  { name: 'สุรินทร์', lat: 14.8829, lng: 103.4937 },
  { name: 'ศรีสะเกษ', lat: 15.1186, lng: 104.3220 },
  { name: 'ยโสธร', lat: 15.7944, lng: 104.1451 },
  { name: 'อุบลราชธานี', lat: 15.2287, lng: 104.8564 },
  { name: 'อำนาจเจริญ', lat: 15.8656, lng: 104.6263 },

  // ภาคกลาง
  { name: 'กรุงเทพมหานคร', lat: 13.7563, lng: 100.5018 },
  { name: 'นนทบุรี', lat: 13.8622, lng: 100.5144 },
  { name: 'ปทุมธานี', lat: 14.0208, lng: 100.5253 },
  { name: 'สมุทรปราการ', lat: 13.5991, lng: 100.5998 },
  { name: 'สมุทรสาคร', lat: 13.5475, lng: 100.2744 },
  { name: 'สมุทรสงคราม', lat: 13.4098, lng: 100.0024 },
  { name: 'นครปฐม', lat: 13.8199, lng: 100.0645 },
  { name: 'พระนครศรีอยุธยา', lat: 14.3692, lng: 100.5877 },
  { name: 'อ่างทอง', lat: 14.5896, lng: 100.4549 },
  { name: 'สิงห์บุรี', lat: 14.8936, lng: 100.3967 },
  { name: 'ลพบุรี', lat: 14.7995, lng: 100.6534 },
  { name: 'สระบุรี', lat: 14.5289, lng: 100.9103 },
  { name: 'ชัยนาท', lat: 15.1851, lng: 100.1251 },
  { name: 'สุพรรณบุรี', lat: 14.4744, lng: 100.1177 },
  { name: 'กาญจนบุรี', lat: 14.0227, lng: 99.5328 },
  { name: 'ราชบุรี', lat: 13.5283, lng: 99.8134 },
  { name: 'เพชรบุรี', lat: 13.1112, lng: 99.9392 },
  { name: 'ประจวบคีรีขันธ์', lat: 11.8126, lng: 99.7957 },
  { name: 'นครนายก', lat: 14.2069, lng: 101.2133 },

  // ภาคตะวันออก
  { name: 'ฉะเชิงเทรา', lat: 13.6904, lng: 101.0780 },
  { name: 'ชลบุรี', lat: 13.3611, lng: 100.9847 },
  { name: 'ระยอง', lat: 12.6814, lng: 101.2816 },
  { name: 'จันทบุรี', lat: 12.6113, lng: 102.1039 },
  { name: 'ตราด', lat: 12.2428, lng: 102.5175 },
  { name: 'ปราจีนบุรี', lat: 14.0509, lng: 101.3715 },
  { name: 'สระแก้ว', lat: 13.8240, lng: 102.0646 },

  // ภาคใต้
  { name: 'ชุมพร', lat: 10.4930, lng: 99.1800 },
  { name: 'ระนอง', lat: 9.9529, lng: 98.6085 },
  { name: 'สุราษฎร์ธานี', lat: 9.1382, lng: 99.3217 },
  { name: 'พังงา', lat: 8.4509, lng: 98.5253 },
  { name: 'กระบี่', lat: 8.0863, lng: 98.9063 },
  { name: 'ภูเก็ต', lat: 7.8804, lng: 98.3923 },
  { name: 'นครศรีธรรมราช', lat: 8.4322, lng: 99.9631 },
  { name: 'ตรัง', lat: 7.5564, lng: 99.6114 },
  { name: 'พัทลุง', lat: 7.6167, lng: 100.0743 },
  { name: 'สงขลา', lat: 7.1897, lng: 100.5954 },
  { name: 'สตูล', lat: 6.6238, lng: 100.0673 },
  { name: 'ปัตตานี', lat: 6.8686, lng: 101.2505 },
  { name: 'ยะลา', lat: 6.5414, lng: 101.2803 },
  { name: 'นราธิวาส', lat: 6.4255, lng: 101.8253 },
];

export default THAILAND_PROVINCE_COORDINATES;
